import { useCampaignData } from '@/hooks'
import { CampaignAnalytics } from '@/ui'
import {
	useAnalyticsAdditionalQuestionsAnalytics,
	useAnalyticsCampaignAnalytics,
	useAnalyticsCampaignMetaAnalytics,
	useAnalyticsFormDropoffAnalytics,
	useAnalyticsWhatsAppCampaignAnalytics,
	usePipelineStageShow,
} from '@jobilla/nexus-sdk'
import { createFileRoute } from '@tanstack/react-router'
import { useState } from 'react'

function getDefaultDateRange() {
	return {
		start_date: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
		end_date: new Date().toISOString().split('T')[0],
	}
}

export const Route = createFileRoute(
	'/_auth/company/$companyId/$campaignId/analytics',
)({
	component: RouteComponent,
})

function RouteComponent() {
	const params = Route.useParams()
	const { campaign } = useCampaignData({ campaignId: params.campaignId })

	const [dropoffDateRange, setDropoffDateRange] = useState(getDefaultDateRange)
	const [additionalQuestionsDateRange, setAdditionalQuestionsDateRange] = useState(getDefaultDateRange)
	const [whatsAppDateRange, setWhatsAppDateRange] = useState(getDefaultDateRange)

	const { data: analyticsData, isLoading: isLoadingAnalytics } = useAnalyticsCampaignAnalytics(
		params.campaignId,
	)

	const { data: metaAnalyticsData, isLoading: isLoadingMetaAnalytics } = useAnalyticsCampaignMetaAnalytics(
		params.campaignId,
	)

	const { data: dropoffAnalyticsData, isLoading: isLoadingDropoffAnalytics } = useAnalyticsFormDropoffAnalytics(
		params.campaignId,
		dropoffDateRange,
	)

	const { data: additionalQuestionsData, isLoading: isLoadingAdditionalQuestions } =
		useAnalyticsAdditionalQuestionsAnalytics(
			params.campaignId,
			additionalQuestionsDateRange,
		)

	const { data: whatsAppData, isLoading: isLoadingWhatsApp } = useAnalyticsWhatsAppCampaignAnalytics(
		params.campaignId,
		whatsAppDateRange,
	)

	const { data: pipelineData, isLoading: isLoadingCandidates } = usePipelineStageShow(params.campaignId)

	const handleDropoffDateRangeChange = (startDate: string, endDate: string) => {
		setDropoffDateRange({ start_date: startDate, end_date: endDate })
	}

	const handleAdditionalQuestionsDateRangeChange = (startDate: string, endDate: string) => {
		setAdditionalQuestionsDateRange({ start_date: startDate, end_date: endDate })
	}

	const handleWhatsAppDateRangeChange = (startDate: string, endDate: string) => {
		setWhatsAppDateRange({ start_date: startDate, end_date: endDate })
	}

	return (
		<CampaignAnalytics
			loading={{
				analytics: isLoadingAnalytics,
				metaAnalytics: isLoadingMetaAnalytics,
				candidates: isLoadingCandidates,
				dropoffAnalytics: isLoadingDropoffAnalytics,
				additionalQuestionsAnalytics: isLoadingAdditionalQuestions,
				whatsAppAnalytics: isLoadingWhatsApp,
			}}
			view={{
				campaign,
				analytics: analyticsData ?? null,
				metaAnalytics: metaAnalyticsData ?? null,
				candidates: pipelineData?.candidates ?? [],
				dropoffAnalytics: dropoffAnalyticsData ?? null,
				additionalQuestionsAnalytics: additionalQuestionsData ?? null,
				whatsAppAnalytics: whatsAppData ?? null,
				whatsAppDateRange,
			}}
			events={{
				onDropoffDateRangeChange: handleDropoffDateRangeChange,
				onAdditionalQuestionsDateRangeChange: handleAdditionalQuestionsDateRangeChange,
				onWhatsAppDateRangeChange: handleWhatsAppDateRangeChange,
			}}
		/>
	)
}
